import { BounceZoomIn, ZoomOut } from "slotworks/graphics/animation/base-animations";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import { Group, Ungroup } from "slotworks/graphics/pixi/group";
import Contract from "slotworks/utils/contracts/contract";
import * as TweenJS from "slotworks/utils/tween";

export default class ModalTransition extends AbstractSceneTransition {

    private duration: number;
    private group: PIXI.Container;
    private tweenContract: Contract<void>;
    private resolve: Function;

    constructor(layer: Layers, duration: number) {
        super(layer);

        this.duration = duration;
    }

    public in(): Contract<void> {
        if (this.layer) {
            return this.startAnimation(BounceZoomIn, this.duration);
        }

        return Contract.empty();
    }

    public out(): Contract<void> {
        if (this.layer) {
            return this.startAnimation(ZoomOut, this.duration * 0.5);
        }

        return Contract.empty();
    }

    private startAnimation(tweenFunction: (...agrs: any[]) => Contract<void>, duration: number) {
        return new Contract<void>((resolve) => {

            const clearBinding = this.layer.preOrientationChange.add(() => this.clearZoom());
            const zoomBinding = canvasManager.onOrientationChange.add(() => this.animate(tweenFunction, duration));

            this.resolve = () => {
                clearBinding.detach();
                zoomBinding.detach();
                resolve();
            };

            this.animate(tweenFunction, duration);
        });
    }

    private clearZoom() {
        if (this.tweenContract) {
            TweenJS.removeAll(this.group);
            TweenJS.removeAll(this.group.scale);
            this.tweenContract.cancel();
            Ungroup(this.group);
        }
    }

    private animate(tweenFunction: (...args: any[]) => Contract<void>, duration: number) {
        this.group = Group(this.layer.container.children as PIXI.Container[]);

        this.tweenContract = tweenFunction(this.group, duration);
        this.tweenContract.then(() => this.resolve());
    }
}
